export const CACHE_LIST_ACTION = "CACHE_LIST_ACTION";
export const CACHE_LIST_SUCCESS = "CACHE_LIST_SUCCESS";
export const CACHE_LIST_FAIL = "CACHE_LIST_SUCCESS";
export const CACHE_DELETE_ACTION = "CACHE_DELETE_ACTION";
export const CACHE_DELETE_SUCCESS = "CACHE_DELETE_SUCCESS";
export const CACHE_DELETE_FAIL = "CACHE_DELETE_FAIL";